module.exports = __webpack_public_path__ + "img/cargo-unavailable.c3ce921e.svg";